/**
 * HelpTip — small inline (?) icon that opens a Radix Popover with a
 * short explanation. Use anywhere a field name isn't self-evident to
 * a new user. Keep the body to a sentence or two; if you need more,
 * link out to a docs page from inside the popover.
 *
 *   <label>Two Answer Mode <HelpTip>...</HelpTip></label>
 */
import type { ReactNode } from 'react';
import { Popover, IconButton, Text } from '@radix-ui/themes';

interface Props {
  children: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
}

const HelpTip: React.FC<Props> = ({ children, side = 'top' }) => {
  return (
    <Popover.Root>
      <Popover.Trigger>
        <IconButton
          variant="ghost"
          size="1"
          color="gray"
          aria-label="What is this?"
          style={{ marginLeft: 4, verticalAlign: 'middle' }}
          onClick={(e) => e.preventDefault()}
        >
          ?
        </IconButton>
      </Popover.Trigger>
      <Popover.Content side={side} maxWidth="320px">
        <Text size="2" as="div" style={{ lineHeight: 1.45 }}>
          {children}
        </Text>
      </Popover.Content>
    </Popover.Root>
  );
};

export default HelpTip;
